import apiClient from "@/helpers/http-common";

export default {
    async post(logger) {
        // console.log(logger);
        return await apiClient.post("/api/logger", {
            user_id: "wordpress",
            source: "corporate website",
            request_string: logger
        });
    }
};
